const pattern = /{cardssort:({.+})}/;

export default pattern;